module.exports = __webpack_public_path__ + "img/mobile-map-location.7edf24d5.svg";